import axios from 'axios';

const postData = config => {
  if (config && config.params) {
    return axios.post(config.url, {
      params: config.params
    });
  }
  return axios.post(config.url);
}

const postDataHeader = async ({ url, body, headers }) => {
  try {
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error('Error en la solicitud POST con encabezados:', error);
    throw error;
  }
}

export default postData;
export { postDataHeader };

